(function(){
'use strict';

angular.module('classy').component('formField', {
  template: '<div class="form-field" data-ng-transclude></div>',
  transclude: true
});
})();